<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                passive
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('common_words.perimeter_status_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            top="2%"
            width="60%"
            :title="$t('common_words.perimeter_status_add')"
            :visible.sync="modals.create"
            :close-on-click-modal="false"
          >
            <form>
              <div class="row">
                <div class="col-12 custom-perimeter-dialog">
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <fg-input
                        type="text"
                        :label="`${$t('common_words.name')}: *`"
                        v-model="model.name"
                        name="common_words.name"
                        v-validate="modelValidations.name"
                        :error="getError('common_words.name', true)"
                        :placeholder="`${$t('common_words.create')}...`"
                      >
                      </fg-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-4 col-lg-4 col-xl-4">
                      <label>{{ $t('labor.unit') }} *</label>
                      <br />
                      <el-select
                        filterable
                        style="width: 100%"
                        class="select-primary mb-3 shadow-sm required-unit"
                        v-model="model.unit"
                        :placeholder="`${$t('common_words.select2')}...`"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in [
                            { id: 'm2', value: 'M2' },
                            { id: 'ha', value: 'Ha' },
                          ]"
                          :key="item.id + item.value"
                          :label="item.value"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div class="col-12 col-sm-4 col-lg-4 col-xl-4">
                      <label>{{ $t('common_words.detail') }} *</label>
                      <br />
                      <el-select
                        filterable
                        style="width: 100%"
                        class="select-primary mb-3 shadow-sm required-detail"
                        v-model="model.eradication"
                        :placeholder="`${$t('common_words.select2')}...`"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in [
                            { id: 0, value: 'No' },
                            { id: 1, value: 'Si' },
                          ]"
                          :key="item.id + item.value"
                          :label="item.value"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div class="col-12 col-sm-4 col-lg-4 col-xl-4">
                      <fg-input
                        type="number"
                        style="width: 100%"
                        :label="`${$t('common_words.order')}: *`"
                        v-model="model.order"
                        name="common_words.order"
                        v-validate="modelValidations.order"
                        :error="getError('common_words.order', true)"
                        :placeholder="`${$t('common_words.choose')}...`"
                      >
                      </fg-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <div class="form-group has-label">
                        <label>{{ $t('common_words.companies') }} *</label>
                        <br />
                        <el-select
                          collapse-tags
                          @change="
                            selectAllFromSelect(
                              'model.businesses_ids',
                              businesses
                            )
                          "
                          clearable
                          multiple
                          filterable
                          style="width: 100%"
                          class="select-primary custom-width-select mb-3shadow-sm required-business"
                          v-model="model.businesses_ids"
                          :placeholder="`${$t('common_words.select')}...`"
                        >
                          <el-option
                            v-for="option in businesses"
                            class="select-primary selected-all"
                            :value="option.id"
                            :label="option.name"
                            :key="option.id"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group has-label">
                        <label>{{ $t('common_words.color') }} *</label>
                        <sketch-picker
                          :value="colors"
                          @input="updateValue"
                          v-if="renderComponent"
                        ></sketch-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                {{ $t('common_words.cancel') }}</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                {{ $t('common_words.save') }}
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :cell-style="handlecellstyle"
              :default-sort="{ prop: 'name', order: 'ascending' }"
              :data="queriedData"
              max-height="500"
              style="width: 100%"
              :border="true"
            >
              <!-- <el-table-column type="index" width="65"></el-table-column> -->
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                :label="$t('common_words.color')"
                min-width="90"
                :sortable="true"
                :resizable="false"
                align="center"
              >
                <template slot-scope="props">
                  <div class="text">
                    <span style="mix-blend-mode: difference">{{
                      props.row.color
                    }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                min-width="90"
                prop="props.businesses_registered"
                :label="$t('common_words.associated_companies2')"
                :sortable="true"
                :resizable="false"
                align="center"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.businesses_registered.length > 0"
                    :hidden="
                      scope.row.businesses_registered.length == 1 ? true : false
                    "
                    :value="scope.row.businesses_registered.length - 1"
                    :max="scope.row.businesses_registered.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ scope.row.businesses_registered[0].name }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="90"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      top="2%"
      v-if="isShow()"
      :title="$t('common_words.record_selected_threepoints')"
      :visible.sync="modals.read"
      width="60%"
    >
      <p>
        {{ $t('common_words.selected_record_info') }}
      </p>
      <div class="card" v-if="rowData">
        <div class="card-body" v-if="rowData">
          <table class="table">
            <tbody>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('common_words.name') }}:</strong>
                  </h6>
                  {{ rowData.name }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td :style="'background-color: ' + rowData.color" scope="row">
                  <h6>
                    <strong>{{ $t('common_words.color') }}:</strong>
                  </h6>
                  {{ rowData.color }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('labor.unit') }}:</strong>
                  </h6>
                  <span v-html="rowData.unit"></span>
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('common_words.order') }}:</strong>
                  </h6>
                  {{ rowData.order }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('common_words.detail') }}:</strong>
                  </h6>
                  <span v-html="rowData.eradication_name"></span>
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6 class="mb-2">
                    <strong
                      >{{ $t('common_words.registered_companies') }}:</strong
                    >
                  </h6>
                  <span
                    v-for="(b, index) in rowData.businesses_registered"
                    :key="index"
                  >
                    <el-tag type="info">{{ b.name }}</el-tag>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer footer-date-at" v-if="rowData">
          <p class="text-muted">
            <small
              >{{ $t('common_words.created_on') }}:
              {{ rowData.created_at }}</small
            >
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './perimeter-conditions-table';
import i18n from '../../../../i18n';
import MixinColors from 'src/util/mixinColor';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    LPagination,
  },

  computed: {
    ...configTable().Search,
  },

  data() {
    return {
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        create: false,
      },
      model: {
        name: null,
        unit: null,
        order: null,
        eradication: null,
        color: null,
        businesses_ids: [],
      },
      modelValidations: {
        name: {
          required: true,
        },
        order: {
          required: true,
          min_value: 0,
        },
      },
      businesses: [],
    };
  },

  mixins: [
    MixinColors,
    MixinExport,
    MixinForm,
    MixinMasters,
    MixinMenu,
    MixinNotification,
    MixinPermissions,
    MixinValidations,
  ],

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },

    openModal(name) {
      if (name == 'create') {
        sessionStorage.removeItem('editForm');
        this.title = i18n.t('common_words.perimeter_status_add');
        this.$validator.reset();
        this.model.name = null;
        this.model.businesses_ids = [];
        this.model.color = this.colors;
        this.model.eradication = 0;
        this.model.unit = 'ha';
        this.model.order = null;
      }
      this.modals[name] = true;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.unit)) {
            return this.validationInputsRequired('unit');
          } else if (!isset(this.model.eradication)) {
            return this.validationInputsRequired('detail');
          }
          if (!isset(this.model.businesses_ids)) {
            return this.validationInputsRequired('business');
          } else {
            this.addPerimeterCondition();
          }
        }
      });
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      row.url_path_form = 'diseases/perimeterconditions';
      sessionStorage.setItem('editForm', JSON.stringify(row));
      this.title = i18n.t('common_words.perimeter_status_edit') + row.version;
      this.model = Object.assign({}, row);
      this.$set(
        this.model,
        'businesses_ids',
        row.businesses_registered.map((business) => business.id)
      );
      this.errors.clear();
      this.model.route = 'diseases/perimeterconditions';
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.model = row;
      SweetAlert.delete(this.model.name).then((result) => {
        if (result.value) this.deletePerimeterCondition();
      });
    },

    handlecellstyle({ row, columnIndex }) {
      if (row.color && columnIndex == 4) {
        return 'background-color: ' + row.color;
      }
    },

    addPerimeterCondition() {
      this.showHideLoading(true);
      this.model.route = 'diseases/perimeterconditions';
      if (this.isCreate() && !sessionStorage.getItem('editForm')) {
        Axios.saveMaster(this.model)
          .then((response) => {
            this.modifyTable(0, null, response);
          })
          .catch((error) => {
            this.closeModal('create');
            this.showPerimeterCondition(
              ` ${error.response.data.message}`,
              'danger',
              'nc-simple-add',
              i18n.t('common_words.alert')
            );
            this.showHideLoading();
          });
      } else if (this.isUpdate() && sessionStorage.getItem('editForm')) {
        this.model.id = JSON.parse(sessionStorage.getItem('editForm')).id;
        Axios.updateMaster(this.model)
          .then((response) => {
            this.modifyTable(1, this.model.id, response);
            sessionStorage.removeItem('editForm');
          })
          .catch((error) => {
            this.closeModal('create');
            this.showPerimeterCondition(
              ` ${error.response.data.message}`,
              'danger',
              'nc-simple-add',
              `${i18n.t('common_words.alert')}...`
            );
            this.showHideLoading();
            sessionStorage.removeItem('editForm');
          });
      }
    },

    deletePerimeterCondition() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'diseases/perimeterconditions';
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.modifyTable(2, this.model.id, response);
          })
          .catch((error) => {
            this.showHideLoading();
            SweetAlert.danger(
              error.response.data.message ? error.response.data.message : error
            );
          });
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'diseases/perimeterconditions/pdf';
      data.name_file = `${i18n.t('diseases.perimeter_conditions')}.pdf`;

      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'diseases/perimeterconditions/excel';
      data.name_file = `${i18n.t('diseases.perimeter_conditions')}.xlsx`;

      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('diseases/perimeterconditions'),
        Axios.getMasters('businesses/only'),
      ])
        .then((response) => {
          const [response_perimetercondition, response_businesses] = response;
          this.tableData = response_perimetercondition.data.data;
          this.businesses = this.concatAll(response_businesses.data.data);
          this.searchFuse(
            this.tableColumns.map((column) => {
              return column.prop;
            })
          );
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.model.color = this.colors; //.hex
    this.selectedItemOnMenu('diseases');
  },

  destroyed() {
    this.deselectedItemOnMenu('diseases');
  },
};
</script>

<style scoped>
.custom-perimeter-dialog {
  padding-right: 15px !important;
}
</style>
